if (!customElements.get('rli-countdown-timer')) {
  /*
    RLI compliance fix Oct 2026.
    Was: a "recurring daily" timer that counted to the same clock time every day and restarted
    (a fake deadline, banned under the UK DMCC Act 2024 Sch. 20 and the EU UCPD Annex I no. 7).
    Now: counts down to ONE fixed end in UK time (data-end-uk="YYYY-MM-DD HH:MM"), the same moment
    for every visitor, never restarts, and hides itself (and, if asked, its announcement) at the end
    or when no valid end is set.
  */
  class RliCountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.second = 1000;
      this.minute = 60 * this.second;
      this.hour = 60 * this.minute;
      this.day = 24 * this.hour;
      this.end = RliCountdownTimer.londonEnd(this.dataset.endUk || '');
      if (!Number(this.end) || this.end <= Date.now()) { this.finish(); return; }
      this.init();
    }

    init() {
      this.daysEl = this.querySelector('.js-days .countdown__number-part-1');
      this.daysItem = this.querySelector('.js-days') ? this.querySelector('.js-days').closest('.countdown__item') : null;
      this.hoursPart1El = this.querySelector('.js-hours .countdown__number-part-1');
      this.hoursPart2El = this.querySelector('.js-hours .countdown__number-part-2');
      this.minsPart1El = this.querySelector('.js-mins .countdown__number-part-1');
      this.minsPart2El = this.querySelector('.js-mins .countdown__number-part-2');
      this.secsPart1El = this.querySelector('.js-secs .countdown__number-part-1');
      this.secsPart2El = this.querySelector('.js-secs .countdown__number-part-2');
      this.timer();
      this.interval = setInterval(this.timer.bind(this), this.second);
    }

    finish() {
      if (this.interval) clearInterval(this.interval);
      this.style.display = 'none';
      var chip = this.parentElement;
      if (chip) chip.style.display = 'none';
      if (this.dataset.hideAnnouncement === 'true') {
        var ann = this.closest('.announcement');
        if (ann) ann.style.display = 'none';
      }
      this.setAttribute('loaded', '');
    }

    timer() {
      var d = this.end - Date.now();
      if (d <= 0) { this.finish(); return; }
      var days = Math.floor(d / this.day);
      var hours = Math.floor((d % this.day) / this.hour);
      var mins = Math.floor((d % this.hour) / this.minute);
      var secs = Math.floor((d % this.minute) / this.second);
      if (this.daysEl) this.daysEl.textContent = String(days);
      if (this.daysItem) this.daysItem.style.display = days > 0 ? '' : 'none';
      var hh = String(hours).padStart(2, '0'), mm = String(mins).padStart(2, '0'), ss = String(secs).padStart(2, '0');
      if (this.hoursPart1El) this.hoursPart1El.textContent = hh[0];
      if (this.hoursPart2El) this.hoursPart2El.textContent = hh[1];
      if (this.minsPart1El) this.minsPart1El.textContent = mm[0];
      if (this.minsPart2El) this.minsPart2El.textContent = mm[1];
      if (this.secsPart1El) this.secsPart1El.textContent = ss[0];
      if (this.secsPart2El) this.secsPart2El.textContent = ss[1];
      this.setAttribute('loaded', '');
    }

    static londonOffset(ms) {
      ms = Math.floor(ms / 1000) * 1000;
      var o = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })
        .formatToParts(new Date(ms)).forEach(function (q) { o[q.type] = q.value; });
      return Date.UTC(+o.year, +o.month - 1, +o.day, (+o.hour) % 24, +o.minute, +o.second) - ms;
    }

    static londonEnd(str) {
      var m = String(str).trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
      if (!m) return NaN;
      var wall = Date.UTC(+m[1], +m[2] - 1, +m[3], m[4] ? +m[4] : 23, m[5] ? +m[5] : 59, 0);
      var t = wall - RliCountdownTimer.londonOffset(wall);
      return wall - RliCountdownTimer.londonOffset(t);
    }
  }

  customElements.define('rli-countdown-timer', RliCountdownTimer);
}

document.querySelectorAll('.rli-announcement-bar').forEach(function (section) {
  var announcements = section.querySelectorAll('.rli-announcement');
  if (announcements.length <= 1) return;

  var current = 0;

  function show(index) {
    announcements.forEach(function (a) { a.classList.remove('is-active'); });
    announcements[index].classList.add('is-active');
    current = index;
  }

  var prev = section.querySelector('.rli-prev');
  var next = section.querySelector('.rli-next');

  if (prev) prev.addEventListener('click', function () {
    show((current - 1 + announcements.length) % announcements.length);
  });

  if (next) next.addEventListener('click', function () {
    show((current + 1) % announcements.length);
  });
});